import {
  Checkmark20Regular,
  Copy20Regular,
  ThumbDislike20Filled,
  ThumbDislike20Regular,
  ThumbLike20Filled,
  ThumbLike20Regular,
} from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

export default function AssistantMessageCopyFeedbackActions({ copied, handleCopy, feedback, toggleGood, toggleBad }) {
  return (
    <>
      <Tooltip text="copy" placement="bottom">
        <button type="button" className={styles.actionButton} aria-label="Copy message" onClick={handleCopy}>
          {copied ? <Checkmark20Regular /> : <Copy20Regular />}
        </button>
      </Tooltip>
      <Tooltip text="good response" placement="bottom">
        <button
          type="button"
          className={`${styles.actionButton}${feedback === 'good' ? ` ${styles.goodActive}` : ''}`}
          aria-label="Good response"
          aria-pressed={feedback === 'good'}
          onClick={toggleGood}
        >
          {feedback === 'good' ? <ThumbLike20Filled /> : <ThumbLike20Regular />}
        </button>
      </Tooltip>
      <Tooltip text="Bad response" placement="bottom">
        <button
          type="button"
          className={`${styles.actionButton}${feedback === 'bad' ? ` ${styles.badActive}` : ''}`}
          aria-label="Bad response"
          aria-pressed={feedback === 'bad'}
          onClick={toggleBad}
        >
          {feedback === 'bad' ? <ThumbDislike20Filled /> : <ThumbDislike20Regular />}
        </button>
      </Tooltip>
    </>
  )
}
